import { render, staticRenderFns } from "./ModalPrevTempMail.vue?vue&type=template&id=9a27db16&scoped=true&"
import script from "./ModalPrevTempMail.vue?vue&type=script&lang=js&"
export * from "./ModalPrevTempMail.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrevTempMail.vue?vue&type=style&index=0&id=9a27db16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a27db16",
  null
  
)

export default component.exports